import './theme/index.scss'
import kamala from './kamala'
import * as kComponents from './components'
import _ from 'lodash'
// import { window } from 'ssr-window'
// import $ from 'jquery'
//
// window.$ = $

function getComponentOption(options, component) {
  let componentName = ''
  if (component.name) {
    componentName = component.name.toLowerCase()
  }

  return options[componentName]
}

function standardizeOptionsKey(options) {
  options = _.each(options, (v, k) => {
    let key
    const lowerKey = _.toLower(k).replace(' ', '')
    if (lowerKey.substring(0, 1) !== 'k') {
      key = 'k' + lowerKey
    } else {
      key = lowerKey
    }
    options[key] = v
  })
  return options
}

const install = function (Vue, options = {}) {
  // install kamala basic abilities
  kamala(Vue)
  options = standardizeOptionsKey(options)
  // register components or directives
  Object.values(kComponents).forEach((kComponent) => {
    Vue.use(kComponent, getComponentOption(options, kComponent))
  })
}

// if (typeof window !== 'undefined' && window.Vue) {
//   install(window.Vue)
// }

export default { install }

// components
export * from './components'
export const { KRow, KCol } = kComponents.KGrid
export const { KLayout, KHeader, KAside, KFooter, KMain } = kComponents.KLayoutFamily
export const { KMenu, KSubMenu, KMenuItem, KMenuItemGroup } = kComponents.KMenuFamily
export const { KBreadcrumb, KBreadcrumbItem } = kComponents.KBreadcrumbFamily
export const { KCarouselItem, /* KCarouselIndicator, */ KCarousel } = kComponents.KCarouselFamily
export const { KDropdown, KDropdownMenu, KDropdownItem, KTriggerIndicator } = kComponents.KDropdownFamily
export const { KTabs, KTabPane } = kComponents.KTabsFamily
export const { KDataGrid, KDataGridColumn, SelectionMode } = kComponents.KDataGridFamily
export const { KRadio, KRadioGroup, KRadioButton } = kComponents.KRadioFamily
export const { KInput, KTextArea } = kComponents.KInputFamily
export const { KSelect, KOptgroup, KOption } = kComponents.KSelectFamily
export const { KForm } = kComponents.KFormFamily
export const { KList, KListItem } = kComponents.KListFamily
export const { KTimeline, KTimelineItem } = kComponents.KTimelineFamily
export const { KTag, KTagGroup } = kComponents.KTagFamily
export const { KCalendar } = kComponents.KCalendarFamily
export const {
  KCollapseTransition,
  KBounceTopTransition,
  KBounceLeftTransition,
  KBounceBottomTransition,
  KBounceRightTransition,
  KBounceTransition,
  KTransitionAnimation,
} = kComponents.KTransitionFamily

// utils
export * from './core/utils/index'
export * from './core/mixins/index'

// config
export { default as KConfig } from './core/KConfig'
